import type { Message } from 'src/services/apollo/generated/graphql'

const defaultFlags = {
  isMinors: false,
  isSensitive: false,
}

export function getCommentTextModerationInfo(extra?: Message['extra']) {
  const info = {
    ...defaultFlags,
    ...(extra?.textModerationInfo ?? {}),
  }
  const isFlagged = info.isMinors || info.isSensitive

  return {
    ...info,
    isFlagged,
  }
}
